import React from 'react'
import { useIsMobile } from '@grupoboticario/flora-react-hooks'
import { DropdownNative } from './DropdownNative'
import { DropdownInput } from './DropdownInput'
import { DropdownProps } from './libs/useDropdown'
import { forwardRef } from '@grupoboticario/flora-react-system'

/**
 * @component
 * @name Dropdown
 * @description Dropdown component
 * @tutorial https://flora.gb.tech/docs/components/core/dropdown
 */
export const Dropdown = forwardRef<'select', DropdownProps>((props, forwardedRef) => {
  const isMobile = useIsMobile()
  const isNative = props.disableNativeOnMobile ? false : props.native || isMobile
  const InputComponent: React.ElementType = isNative ? DropdownNative : DropdownInput

  return <InputComponent {...props} native={isNative} ref={forwardedRef} />
})
